import {CommonModule} from '@angular/common';
import {Component, computed, inject, input} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {SvgIconComponent} from 'angular-svg-icon';
import {MenuItem} from 'src/domain/sidebar';
import {GenericAuthService} from 'src/infrastructure/generic-auth/generic-auth.service';

@Component({
    selector: 'app-menu-item',
    standalone: true,
    imports: [CommonModule, SvgIconComponent, TranslateModule, RouterModule],
    templateUrl: './menu-item.component.html',
    styleUrl: './menu-item.component.scss'
})
export class MenuItemComponent
{
    private readonly genericAuthService = inject(GenericAuthService);

    public readonly userType = computed(() => this.genericAuthService.loggedUserType());

    public menuItem = input.required<MenuItem>();

    public isSelected = input<boolean>();
}
